import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './layout/Sidebar';
import Dashboard from './pages/Dashboard';
import ConversationalAI from './pages/ConversationalAI';
import Radiology from './pages/Radiology';
import Chatbot from './pages/Chatbot';
import NegotiationBot from './pages/NegotiationBot';
import WhatsAppIntegration from './pages/WhatsAppIntegration';
import AIAvatar from './pages/AIAvatar';
import DocFussion from './pages/DocFussion';
import Login from './components/Auth/Login';
import Logout from './components/Auth/Logout';

function hasValidSession() {
  if (typeof window === 'undefined') return false;
  // Only trust v2 session to avoid stale legacy sessions
  const raw = localStorage.getItem('maskan_auth_v2');
  if (!raw) return false;
  try {
    const obj = JSON.parse(raw);
    if (!obj || typeof obj !== 'object') return false;
    const u = obj.user || {};
    // require at least an id or email to consider it valid
    const okUser = Boolean(u && (u.id || u.email || u.username));
    if (!okUser) return false;
    // basic TTL (24h) to avoid very old sessions
    const ts = obj.ts || 0;
    const maxAgeMs = 24 * 60 * 60 * 1000;
    return Date.now() - ts < maxAgeMs;
  } catch {
    return false;
  }
}

export default function App() {
  const location = useLocation();
  const authed = hasValidSession();

  // If not authenticated, only expose the /login route and redirect everything else to /login.
  if (!authed) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <div className="layout">
      <Sidebar />
      <div className="content">
        <Routes>
          {/* If already authenticated and user hits /login, send them home */}
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/conversational-ai" element={<ConversationalAI />} />
          <Route path="/radiology" element={<Radiology />} />
          <Route path="/chatbot" element={<Chatbot />} />
          <Route path="/negotiation-chatbot" element={<NegotiationBot />} />
          <Route path="/whatsapp" element={<WhatsAppIntegration />} />
          <Route path="/ai-avatar" element={<AIAvatar />} />
          <Route path="/docfussion" element={<DocFussion />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}
